import { render, staticRenderFns } from "./coreSubPage.vue?vue&type=template&id=41f8412c"
import script from "./coreSubPage.vue?vue&type=script&lang=js"
export * from "./coreSubPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports